var HomeCtrl = function () {};
export default HomeCtrl;